import { render } from "./MatrixType.vue?vue&type=template&id=67414c3f"
import script from "./MatrixType.vue?vue&type=script&lang=js"
export * from "./MatrixType.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__